import React from 'react';
import {SVGDefinitions} from '@homeaway/react-svg';

const DateRangePickerSVGDefinitions = () => (
    <SVGDefinitions>
        <symbol id="SVG_CALENDAR_ARRIVE__16">
            <svg
                data-id="SVG_CALENDAR_ARRIVE__16"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
            >
                <g fill="none" fillRule="evenodd">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1.703 8.565H4.99V5.277M.806 4.379l4.186 4.187"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1.703 10.67v2.45a1.5 1.5 0 0 0 1.5 1.5h11.225V4.01a1.5 1.5 0 0 0-1.5-1.5H1.703"
                    />
                    <path
                        fill="currentColor"
                        stroke="none"
                        d="M10.366 9.056h1.892V7.164h-1.892zM10.366 12.563h1.892V10.67h-1.892zM7.119 12.563h1.893V10.67H7.119zM3.874 12.563h1.892V10.67H3.874z"
                    />
                    <path
                        fill="currentColor"
                        stroke="none"
                        d="M10.366 9.056h1.892V7.164h-1.892zM7.119 9.056h1.893V7.164H7.119z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.41.998v1.513M11.2.998v1.513M14.407 5.277H7.119"
                    />
                </g>
            </svg>
        </symbol>
        <symbol id="SVG_CALENDAR_DEPART__16">
            <svg
                data-id="SVG_CALENDAR_DEPART__16"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
            >
                <g fill="none" fillRule="evenodd">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.104 5.09h3.288v3.286M10.206 9.275l4.187-4.186"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.331 10.544v3.95H2.742a1.136 1.136 0 0 1-1.135-1.136V2.385h12.724"
                    />
                    <path
                        fill="currentColor"
                        stroke="none"
                        d="M5.668 8.93H3.776V7.036h1.892zM5.668 12.436H3.776v-1.893h1.892zM8.915 12.436H7.022v-1.893h1.893zM12.16 12.436h-1.892v-1.893h1.892z"
                    />
                    <path
                        fill="currentColor"
                        stroke="none"
                        d="M5.668 8.93H3.776V7.036h1.892zM8.915 8.93H7.022V7.036h1.893z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.623.872v1.513M4.834.872v1.513M1.628 5.151h7.287"
                    />
                </g>
            </svg>
        </symbol>
    </SVGDefinitions>
);

export default DateRangePickerSVGDefinitions;
